import React, { Component } from "react";
import moment from 'moment';
import ImagemFukyo from "../../Components/Imagem-Fukyo/Imagem-Fukyo";





class HighLightsList extends Component {

    constructor(props) {
        super(props);

        this.renderizaCards = this.renderizaCards.bind(this);
        // this.mudaStatusDestaque = this.mudaStatusDestaque.bind(this);
        // this.toggleInativarDestaque = this.toggleInativarDestaque.bind(this);


    }

    renderizaCards(item) {
        let _layout;

        switch (0) {
            case 0:
                _layout = <div className="col-9 px-4">
                    <div className="row">
                        <div className="col-12">
                            <p className="infos-ativos"><strong>Título:</strong> {item.titulo}</p>
                            <p className="infos-ativos"><strong>Descrição:</strong> {item.descricao}</p>
                            <p className="infos-ativos"><strong>Data de publicação:</strong> {moment(item.dtPublicacao).format("DD/MM/YYYY")}</p>
                        </div>
                    </div>
                </div>
                break;
            case 1:
                _layout = <div className="col-9 px-4">
                    <div className="row">
                        <div className="col-12">
                            <p className="infos-ativos"><strong>Anunciante:</strong> {item.anunciante}</p>
                            <p className="infos-ativos"><strong>Tipo de anúncio:</strong> {item.tipoAnuncio}</p>
                            <p className="infos-ativos"><strong>Data de publicação:</strong> {item.dtPublicacao}</p>
                        </div>
                    </div>
                </div>
                break;
            case 2:
                _layout = <div className="col-9 px-4">
                    <div className="row no-gutters">
                        <div className="col-12">
                            <p className="infos-ativos"><strong>Título:</strong> {item.titulo}</p>
                            <p className="infos-ativos"><strong>Seção:</strong> {item.secao}</p>
                            <p className="infos-ativos"><strong>Data de publicação:</strong> {item.dtPublicacao}</p>
                            {/* <p className="infos-ativos"><span className={`badge badge-${Geral.badgeProductType(item.periodico)} badge-periodico`}>{item.periodico}</span></p> */}
                        </div>
                    </div>
                </div>
                break;
            case 3:
                _layout = <div className="col-9 px-4">
                    <div className="row">
                        <div className="col-12">
                            <p className="infos-ativos"><strong>Título:</strong> {item.titulo}</p>
                            <p className="infos-ativos"><strong>Nome do programa:</strong> {item.nomePrograma}</p>
                            <p className="infos-ativos"><strong>Data de publicação:</strong> {item.dtPublicacao}</p>
                            <p className="infos-ativos"><strong>Duração:</strong> {item.duracao}</p>
                        </div>
                    </div>
                </div>
                break;
            case 4:
                _layout = <div className="col-9 px-4">
                    <div className="row">
                        <div className="col-12">
                            <p className="infos-ativos"><strong>Título:</strong> {item.titulo}</p>
                            <p className="infos-ativos"><strong>Nome do programa:</strong> {item.nomePrograma}</p>
                            <p className="infos-ativos"><strong>Data de publicação:</strong> {item.dtPublicacao}</p>
                            <p className="infos-ativos"><strong>Duração:</strong> {item.duracao}</p>
                        </div>
                    </div>
                </div>
                break;
            default:
                _layout = <div className="col-9 px-4">
                    <div className="row no-gutters">
                        <div className="col-12">
                            <p className="infos-ativos"><strong>Título:</strong> {item.titulo}</p>
                            <p className="infos-ativos"><strong>Seção:</strong> {item.secao}</p>
                            <p className="infos-ativos"><strong>Data de publicação:</strong> {item.dtPublicacao}</p>
                            {/* <p className="infos-ativos"><span className={`badge badge-${Geral.badgeProductType(item.periodico)} badge-periodico`}>{item.periodico}</span></p> */}
                        </div>
                    </div>
                </div>
                break;
        }
        return _layout;
    }

    render() {
        const {
            editarDestaque,
            alteraPosicao,
            verificaStatus,
            flagAlteracoes,
            flagSucesso,
            salvarAlteracoes,
            nomeLista,
            listaDestaques,
            abaSelecionada

        } = this.props;
        return (
            <React.Fragment>
                {(!listaDestaques || listaDestaques.length <= 0) && (
                    <div className="col-12 text-center py-3">
                        <h3>Não há destaques ativos cadastrados.</h3>
                    </div>
                )}
                {flagAlteracoes[nomeLista] && (
                    <div className="col-12 text-center pt-4">
                        <div className="card bg-warning py-4">
                            <h5 className="m-0">As alterações só serão registradas após clicar no botão SALVAR ALTERAÇÕES.</h5>
                        </div>
                    </div>
                )}
                {flagSucesso[nomeLista] && (
                    <div className="col-12 text-center pt-4">
                        <i className="text-success">Alterações salvas com sucesso!</i>
                    </div>
                )}
                {!!listaDestaques && listaDestaques.length > 0 && (
                    <div className="col-12 text-center pt-2">
                        <button className="btn btn-outline-success mt-3 mx-1" type="button" name="salvar-alteracoes" disabled={!flagAlteracoes[nomeLista]} onClick={() => salvarAlteracoes(nomeLista)}>Salvar alterações</button>
                    </div>
                )}
                {!!listaDestaques && listaDestaques.length > 0 && listaDestaques.map((item, indice) => {
                    return (
                        <div className="col-lg-8 col-12 pt-2 mt-3 offset-lg-2 offset-0" key={indice}>
                            <div className="row no-gutters">
                                <div className="col-12">
                                    <div className="card bg-white w-100">
                                        <div className={`${abaSelecionada === '1' ? "classe-bsmais" : "classe-hub"} card-header`}>
                                            <div className="row no-gutters">
                                                <div className="col-lg-6 col-12 pb-3 pb-lg-0">
                                                    <div className="row no-gutters">
                                                        <div className="col-lg-6 col-9 text-white border-white">
                                                            <h4 className="m-0">{item.tipoDestaque}</h4>
                                                        </div>
                                                        <div className="col-lg-6 col-3">
                                                            <span className={`badge badge-${item.ativo ? 'success' : 'secondary'} badge-status`}>{item.ativo ? 'Ativo' : 'Inativo'}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-3 col-5">
                                                    <button className="btn btn-sm text-white border-white d-none d-lg-block" type="button" name="editar-destaque" onClick={() => editarDestaque(item)}>Editar destaque</button>
                                                    <button className="btn btn-sm text-white border-white d-lg-none" type="button" name="editar-destaque" onClick={() => editarDestaque(item)}>Editar</button>

                                                </div>
                                                <div className="col-lg-3 col-7 text-right text-white border-white">
                                                    <i className={`${indice === 0 ? 'd-none' : 'cursor-pointer'} fas fa-arrow-up icones-destaques-ativos`} onClick={() => alteraPosicao(indice, -1, nomeLista)}></i>
                                                    <i className={`${indice === (listaDestaques.length - 1) ? 'd-none' : 'cursor-pointer'} fas fa-arrow-down icones-destaques-ativos`} onClick={() => alteraPosicao(indice, +1, nomeLista)}></i>
                                                    <i className={`${item.ativo ? 'far fa-eye-slash' : 'far fa-eye'} icones-destaques-ativos cursor-pointer`} onClick={() => verificaStatus(indice, nomeLista)}></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={`${item.ativo ? '' : 'cartao-inativo'} card-body`}>
                                            <div className="row no-gutters">
                                                <div className="col-3 d-lg-block d-none">
                                                    {/* <img className="img img-fluid" src={item.imagem} alt="imagem-destaque" /> */}
                                                    <ImagemFukyo
                                                        className={`img img-fluid`}
                                                        src={item.imagem}
                                                        alt={`imagem-destaque`}
                                                    />
                                                </div>
                                                {/* {this.renderizaCards(item)} */}
                                                <div className="col-lg-9 col-12  px-lg-4 px-0">
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <p className="infos-ativos"><strong>Título:</strong> {item.titulo}</p>
                                                            <p className="infos-ativos"><strong>Descrição:</strong> {item.descricao}</p>
                                                            <p className="infos-ativos"><strong>Data de publicação:</strong> {moment(item.dtPublicacao).format("DD/MM/YYYY")}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                })
                }
            </React.Fragment >



        )

    }
}
export default HighLightsList;